import type { FaireProductEntity } from "../../entity_types/product";

export const p_4xgw53ydbe: FaireProductEntity = {
  token: "p_4xgw53ydbe",
  type: "product",
  name: "MB FASHION Women’s Ribbed Two-Piece Lounge Set - Long Sleeve Zip Crop Top & High Waist Flared Pants 8199",
  brandToken: "b_e85zy9a2fg",
  brandName: "MB Fashion Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/e3cc1623c947e2f0e149bcdd4e3596ae86f5aae76bf981fc7187a142d5e9a339.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f41d601effd32778f6e95ead09067bef71f73ecc24779b3ca75fa15a14793432.jpeg",
    "https://cdn.faire.com/fastly/efbaf16dbf94b4f003a82ba0e125ec77f40af106c4b1d910cf7a79e2e62ba83d.jpeg",
    "https://cdn.faire.com/fastly/4bbd5d8476fc919372edd4ed7b0c9d9bd43bc14487c9f7410fc2ce508d69ef14.jpeg",
    "https://cdn.faire.com/fastly/3026c12d0a11b96c31f6f038482ace6add131f83b2583494c5e174ec05714dd4.jpeg",
    "https://cdn.faire.com/fastly/7466c9c258f08a0ac52887846278656fb3ac93b336aeea2d0d52d332d32caba3.jpeg",
    "https://cdn.faire.com/fastly/b71dd90c0e658ef7d2c8d1ebc93d3564403f670d3db9dac2a85ffa34af85350b.jpeg",
    "https://cdn.faire.com/fastly/09552049dfddbe024f29fc03ddd67ec21f5a4cf2362d2a9563ff5ffdeaef235a.jpeg",
    "https://cdn.faire.com/fastly/f2f80259c3172dd8e51c66c5acc43cb08836185d8f0c76928c6a3a23b80b5be7.jpeg",
    "https://cdn.faire.com/fastly/f01a5cfe725cacc9cbbe01401a70434cb9044bba9f736ce7b21a578d59cc141d.jpeg",
    "https://cdn.faire.com/fastly/993175ab005c02c9528539e2ab73c7675843410c85d9c14b544a89d0580ca8a4.jpeg",
    "https://cdn.faire.com/fastly/181fdeddffb5164e97acdce5c51b535c8ea7bba9425c704080a2b0c80d41d605.jpeg",
    "https://cdn.faire.com/fastly/4afd8c54aff4f10568486c1c977c0a8bcd6f68fcda9f1a4b577c01c20261f4a5.jpeg",
  ],
  priceDollars: 32.5,
  description:
    "• Trendy Ribbed Design: Soft, stretchy ribbed fabric throughout with exposed seam detailing for a modern, textured look that enhances your silhouette.\n\n• Flattering Fit: Features a cropped long-sleeve zip-up top with a deep V-neckline and high-waisted flared pants that elongate the legs with a subtle bootcut flare.\n\n• Comfortable & Functional: Drawstring waistband for adjustable fit, thumbhole cuffs on sleeves, and full stretch for all-day comfort and ease of movement.\n\n• Superior Stretch: Made from a premium polyester-spandex blend that hugs the body, provides excellent recovery, and moves with you.\n\n• Two-Piece Set Includes: Matching zip-front crop top and pull-on flared leggings, perfect for mixing or wearing as a coordinated outfit.\n\n• Versatile Style: Ideal for lounging at home, casual outings, yoga, travel, or layering; effortlessly transitions from relaxed to chic athleisure looks.\n\n• Easy Care: Machine washable, wrinkle-resistant fabric that retains shape, softness, and fit after repeated wear and washing.\n",
  tags: [],
  msrpDollars: 65,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:15.721Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
